import { NgModule } from '@angular/core';

import { MeLandingPageComponent } from './landing-page.component';
import { BaseModule } from '../../shared/base.module';
import { MeLandingPageHeroComponent } from './landing-page-hero/landing-page-hero.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { LottieModule } from 'ngx-lottie';
import player from "lottie-web";
import { MeLandingPageHowItWorkComponent } from './landing-page-how-it-works/landing-page-how-it-works.component';
import { MeLandingPageMarqueeComponent } from './landing-page-marquee/landing-page-marquee.component';
import { MeLandingPageProofComponent } from './landing-page-proof/landing-page-proof.component';
import { MeLandingPageDataComponent } from './landing-page-data/landing-page-data.component';
import { MeLandingPageQuoteComponent } from './landing-page-quote/landing-page-quote.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MeLandingPageFaqModule } from './share/landing-page-faq/landing-page-faq.module';
import { MeLandingPageImageTextModule } from './share/landing-page-image-text/landing-page-image-text.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { MeLandingPageTextModule } from './share/landing-page-text/landing-page-text.module';
import { MeLandingPageExpertModule } from './share/landing-page-expert/landing-page-expert.module';

export function playerFactory() {
    return player;
  }

@NgModule({
    imports: [
        BaseModule,
        AccordionModule.forRoot(),
        ModalModule.forRoot(),
        CarouselModule,
        MeLandingPageFaqModule,
        MeLandingPageImageTextModule,
        MeLandingPageTextModule,
        MeLandingPageExpertModule,
        StoryBlokLinkModule,
        RatingModule.forRoot(),
        LottieModule.forRoot({ player: playerFactory })
    ],
    declarations: [
        MeLandingPageHeroComponent,
        MeLandingPageHowItWorkComponent,
        MeLandingPageMarqueeComponent,
        MeLandingPageProofComponent,
        MeLandingPageDataComponent,
        MeLandingPageQuoteComponent,
        MeLandingPageComponent,
    ],
    exports: [
        MeLandingPageComponent,
    ]
})
export class LandingPageModule { }
